import React from 'react';
import { useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function GeneratedSingle({storyuuid}) {

  const [story, setStory] = useState([]);
  const [user_prompt, setUserPrompt] = useState([]);
  const [id, setId] = useState([]);
  const [copystatus, setCopyStatus] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await fetch(`${API_URL}/api/story/${storyuuid}`);
      if (response.ok) {
        const results = await response.json();
        setStory(results.story);
        setUserPrompt(results.user_prompt);
        setId(results.id);
      }
      else {
        setStory("Please check again!");
        setUserPrompt("We couldn't find this story!");
      }
    })();
  }, []);

  const printme = () => {
    // Define your HTML content for printing
    const myPrintContent = `
      <html>
        <head>
          <title>Print</title>
        </head>
        <body>
          <h2 style="text-align:center;font-family:sans-serif;"><b>${user_prompt}</b></h2>
          <div style="white-space: pre-line;">
            ${story}
          </div>
          <h3 style="text-align:center;font-family:sans-serif;">Created by me at www.babyboo.dev</h3>
          <hr>
          <div style="width:100%;font-family:sans-serif;color:grey;text-align: center;">My Signature</div>
        </body>
      </html>
    `;

    // Open a new window
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      // Write the content to the new window
      printWindow.document.write(myPrintContent);

      // Invoke the print dialog
      printWindow.document.close(); // Necessary for some browsers
      printWindow.focus(); // Necessary for some browsers
      printWindow.print();
      printWindow.close(); // Close the window after printing (optional)
    }
  };
  
  return (
    <>
        <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }} >
        <div className="col-md-6 col-sm-12">
          <div className="text-center">
              <img id="coloringpage" className="img-fluid message bot print" src='https://butterpuppies.s3.us-west-1.amazonaws.com/static/banner.png' width="33%" />
          </div>
        </div>
        </div>
          <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }}>
          <div className="col-md-6 col-sm-12">
            <h4 className="mb-3 mt-3 text-center">{user_prompt}</h4>
            <div style={{ whiteSpace: 'pre-line' }}>
              {story}
              <p />
            </div>
            
          </div>
            </div>
            <div className="row justify-content-center pb-2" style={{ backgroundColor:"#d5f5e3" }}>
            <div className="col-md-6 col-sm-12 text-center">
                  <button
                        className="btn btn-primary m-1"
                        onClick={() => {
                          navigator.clipboard
                            .writeText(`www.babyboo.dev/story/${id}`)
                            .then(() => setCopyStatus('URL copied to clipboard!'))
                            .catch((err) => console.error('Failed to copy URL:', err));
                        }}
                      >
                        Share URL
                  </button>
                  <button
                    className="btn btn-primary btn-block m-1"
                    onClick={() => (window.location.href = '/stories')}
                  >
                    <b>Create your own Story</b>
                  </button>
                  <div style={{clear:"both", display:"block" }}>{copystatus}</div>
            </div>
            
          </div>
    </>
  );
}
